import { render, staticRenderFns } from "./cardTemplateVip12.vue?vue&type=template&id=68021cb8&scoped=true&"
import script from "./cardTemplateVip12.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip12.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip12.vue?vue&type=style&index=0&id=68021cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68021cb8",
  null
  
)

export default component.exports